import React, { Component } from "react";

import Section from "../components/Section";

class ContactSection extends Component {
  render() {
    return (
      <Section id="contact" className="contact-section">
        <div>Contact Section</div>
      </Section>
    );
  }
}

export default ContactSection;
